import request from '../utils/request';
import {
  DtoCertifyEnterpriseReq,
  DtoCertifyEnterpriseResp,
  DtoEntDictListResp,
  DtoEnterpriseDetailResp,
  DtoEnterpriseUpdateReq,
  LoginResponse,
  RegisterResponse,
} from '@/interfaces/auth';

export const login = (data: { telephone: string; password: string }) => {
  return request<LoginResponse>({ url: '/v1/ent/auth/login', method: 'POST', data });
};

export const openLogin = (data: { openCode: string }) => {
  return request<LoginResponse>({ url: '/v1/ent/auth/login', method: 'POST', data });
};

export const logout = () => {
  return request({ url: '/v1/ent/auth/logout', method: 'POST' });
};

export const sendSmsCode = (data: { telephone: string }) => {
  return request({ url: '/v1/ent/register/send-sms', method: 'POST', data });
};
export const register = (data: { telephone: string; smsCode: string; invitationCode?: string }) => {
  return request<RegisterResponse>({ url: '/v1/ent/register/submit', method: 'POST', data });
};

export const hasSuccessBind = () => {
  return request({ url: '/v1/ent/enterprise/has-success-bound', method: 'GET' });
};

export const getEnterpriseDetail = () => {
  return request<DtoEnterpriseDetailResp>({ url: '/v1/ent/enterprise/detail', method: 'GET' });
};

export const getEntDictList = (data: { type: 'INDUSTRY' | 'REGION' }) => {
  return request<DtoEntDictListResp['data']>({ url: '/v1/ent/dict/list', method: 'POST', data });
};

export const updateEnterpriseDetail = (data: DtoEnterpriseUpdateReq) => {
  return request({ url: '/v1/ent/enterprise/update', method: 'PUT', data });
};

export const certifyEnterprise = (data: DtoCertifyEnterpriseReq) => {
  return request({ url: '/v1/ent/enterprise/certify', method: 'POST', data });
};

export const getCertifyEnterprise = () => {
  return request<DtoCertifyEnterpriseResp>({ url: '/v1/ent/certify/simple-info', method: 'GET' });
};

export const oauth2Empower = (data: {
  appId: string;
  password: string;
  scope: string;
  telephone: string;
}) => {
  return request<{ appName: string; code: string }>({
    url: '/v1/oauth2/empower',
    method: 'POST',
    data,
  });
};

export const oauth2Confirm = (data: { appId: string; code: string; confirm: boolean }) => {
  return request({ url: '/v1/oauth2/empower/confirm', method: 'POST', data });
};

export const getAuthInfo = () => {
  return request({ url: '/v1/ent/auth/info', method: 'GET' });
};

export const larkLogin = (data: { code: string; entId: number }) => {
  return request<LoginResponse>({ url: '/v1/ent/auth/god-login', method: 'POST', data });
};
